import { frontendURL } from '../../../../helper/URLHelper';

const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'csat_reports',
    'attendance_reports',
    'attendance_detail_reports',
    'attendance_agent_reports',
    'scheduled_messages_reports',
    'campaigns_reports',
    'dashboard_apps',
    'closing_reason_reports',
    'campaigns_reports_api',
    'c2w_campaigns_reports_api',
    'call_log_reports_api',
    'api_errors_reports',
    'history_template_events',
    'labels_reports',
    'history_whatsapp_consumptions',
    'history_virtual_assistant_consumptions',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: 'csat_reports',
    },
    {
      icon: 'chat',
      label: 'ATTENDANCE',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/attendances`),
      toStateName: 'attendance_reports',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },
    {
      icon: 'mail-inbox-all',
      label: 'ATTENDANCE_DETAIL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/attendance-details`),
      toStateName: 'attendance_detail_reports',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },
    {
      icon: 'people',
      label: 'ATTENDANCE_AGENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/attendance-agents`),
      toStateName: 'attendance_agent_reports',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },
    {
      icon: 'tag',
      label: 'SCHEDULED_MESSAGES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/scheduled-messages`),
      toStateName: 'scheduled_messages_reports',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },
    {
      icon: 'megaphone',
      label: 'REPORTS_CAMPAIGN',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/campaigns`),
      toStateName: 'campaigns_reports',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },
    {
      icon: 'automation',
      label: 'REPORTS_DASHBOARD_APPS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/dashboard-apps`),
      toStateName: 'reports_dashboard_apps',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },
    {
      icon: 'lock-closed',
      label: 'CLOSING_REASONS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/closing-reasons`),
      toStateName: 'closing_reason_reports',
    },
    {
      icon: 'megaphone',
      label: 'CAMPAIGNS_API',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-campaigns`),
      toStateName: 'campaigns_reports_api',
    },
    {
      icon: 'whatsapp',
      label: 'C2W_CAMPAIGNS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-c2w-campaigns`),
      toStateName: 'c2w_campaigns_reports_api',
    },
    {
      icon: 'telephone',
      label: 'CALL_LOGS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-call-logs`),
      toStateName: 'call_log_reports_api',
    },
    {
      icon: 'error-circle',
      label: 'API_ERRORS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-api-errors`),
      toStateName: 'api_errors_reports',
    },
    {
      icon: 'template',
      label: 'TEMPLATE_EVENTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-template-events`),
      toStateName: 'history_template_events',
    },
    {
      icon: 'tag',
      label: 'LABELS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/labels`),
      toStateName: 'labels_reports',
    },
    {
      icon: 'receipt',
      label: 'WHATSAPP_CONSUMPTIONS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-whatsapp-consumptions`),
      toStateName: 'history_whatsapp_consumptions',
      accountTypes: ['account', 'subaccount', 'parent_account']
    },    
    {
      icon: 'robot',
      label: 'VIRTUAL_ASSISTANT_CONSUMPTIONS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/history-virtual-assistant-consumptions`),
      toStateName: 'history_virtual_assistant_consumptions',
    },
  ],
});

export default reports;
